exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n#usage-select-box select { width: auto; font-size: 14px; font-family: 'Hind'; color: #626262; min-width: 150px; display: inline-block;}\r\n#usage-select-box span { font-size: 16px; font-family: 'Hind'; color: #626262; display: inline-block; margin-bottom: 5px; margin-right: 10px;}\r\n.benchmark-used-feature span { font-size: 14px; font-family: 'Hind'; color: #626262; display: block; margin-bottom: 10px;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/column-chart/column-chart.component.css
// module id = ../../../../../src/app/reports/myReports/zoomView/column-chart/column-chart.component.css
// module chunks = main